import { createSelector } from 'reselect';
export const getVehicleData = (state) => state.domain.vehicle;
export const hasVehiclePinVid = createSelector([getVehicleData], (vehicle) => !!vehicle.pinVid);
export const hasVehicleNadaVid = createSelector([getVehicleData], (vehicle) => !!vehicle.nadaVid);
export const hasVehicleRedbookNumber = createSelector([getVehicleData], (vehicle) => !!vehicle.redbookControlNumber);
//# sourceMappingURL=getVehicleData.js.map